import React, { createContext, ReactNode, useState } from 'react';

type CampaignProviderProps = {
	children: ReactNode;
};

interface ICampaignContextData {
	reloadCommunications: boolean;
	handleSetReloadCommunication: () => void;
}

const CampaignContext = createContext({} as ICampaignContextData);

const CampaignProvider = ({ children }: CampaignProviderProps): JSX.Element => {
	const [reloadCommunications, setReloadCommunications] = useState(false);

	const handleSetReloadCommunication = () => {
		setReloadCommunications(!reloadCommunications);
	};

	return (
		<CampaignContext.Provider
			value={{
				reloadCommunications,
				handleSetReloadCommunication,
			}}
		>
			{children}
		</CampaignContext.Provider>
	);
};

export { CampaignProvider, CampaignContext };
